import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Card, Button, Modal } from "react-bootstrap";
import axios from "axios";
import AdminDashboardLayout from "../../../Components/AdminDashboard/AdminDashboardLayout";
import Loading from "react-fullscreen-loading";
import { toast } from "react-hot-toast";
import Select from "react-select";
import useCountryList from "react-select-country-list";

export default function CreateNewUserProfiles() {
  const navigate = useNavigate();
  const [screenloader, setScreenLoader] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [designation, setDesignation] = useState("");
  const [organization, setOrganization] = useState("");
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [phone, setPhone] = useState("");
  const [country, setCountry] = useState(null);
  const [preferredPaymentMethod, setPreferredPaymentMethod] = useState("Cash");
  const [preferredPaymentTerm, setPreferredPaymentTerm] = useState("Advance");
  const [profileType, setProfileType] = useState("User");
  const [showModal, setShowModal] = useState(false);

  const countries = useCountryList();
  const countryOptions = countries.getData();

  const handleFormSubmit = async (e) => {
    e.preventDefault()
    // console.log({
    //   name,
    //   email,
    //   designation,
    //   organization,
    //   address_line_1: addressLine1,
    //   address_line_2: addressLine2,
    //   country: country?.label,
    //   preferred_payment_method: preferredPaymentMethod,
    //   preferred_payment_term: preferredPaymentTerm,
    //   type: profileType
    // }); 
    if (!name.trim()) {
      toast.error("Name is required");
      return;
    }
    if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) {
      toast.error("Valid email is required");
      return;
    }
    if (!phone.trim()) {
      toast.error("Phone is required");
      return;
    }
    if (!designation.trim()) {
      toast.error("Designation is required");
      return;
    }
    if (!organization.trim()) {
      toast.error("Organization is required");
      return;
    }
    if (!addressLine1.trim()) {
      toast.error("Address Line 1 is required");
      return;
    }
    if (!country) {
      toast.error("Country is required");
      return;
    }
    if (!preferredPaymentMethod) {
      toast.error("Preferred Payment Method is required");
      return;
    }
    if (!profileType) {
      toast.error("Profile Type is required");
      return;
    }

    createUserProfile();
  };

  const handleCloseModal = () => {
    setShowModal(false);
    navigate("/admin/UserProfiles");
  };

  const createUserProfile = async () =>{
    setScreenLoader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/admin/user_profiles`,
        {
          name,
          email,
          phone,
          designation,
          organization,
          address_line_1: addressLine1,
          address_line_2: addressLine2,
          country: country.label,
          preferred_payment_method: preferredPaymentMethod,
          preferred_payment_term: preferredPaymentTerm,
          type: profileType
        },
        {
          headers: {
            "Access-Token": localStorage.getItem("accessToken"),
          },
        }
      );
      setScreenLoader(false);
      if (response.data.status) {
        setShowModal(true);
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      setScreenLoader(false);
      const errorMessage =
        error.response?.data?.message || "Something went wrong";
      toast.error(errorMessage);
    }
  }

  return (
    <div>
      <AdminDashboardLayout />
      <Loading loading={screenloader} background="#fff" loaderColor="#883484" />
      <div className="content-page-bg">
        <div className="content-page">
          <div className="content">
            <h3>Create New User Profile</h3>
            <Container fluid className="behind">
              <Card className="mt-4">
                <Card.Body >
                  <form onSubmit={handleFormSubmit}>
                    <div className="row my-2">
                      <div className="col-lg-6 col-md-6 col-12">
                        <label
                          htmlFor="name"
                          className="form-label"
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          placeholder="Enter name"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="row my-4">
                      <div className="col-lg-6 col-md-6 col-12">
                        <label
                          htmlFor="email"
                          className="form-label"
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          Email
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder="Enter email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                      <div className="col-lg-6 col-md-6 col-12 mt-md-0 mt-4">
                        <label
                          htmlFor="phone"
                          className="form-label"
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          Phone
                        </label>
                        <input
                          type="phone"
                          className="form-control"
                          id="phone"
                          placeholder="Enter phone"
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="row my-4">
                      <div className="col-lg-6 col-md-6 col-12">
                        <label
                          htmlFor="designation"
                          className="form-label"
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          Designation
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="designation"
                          placeholder="Enter designation"
                          value={designation}
                          onChange={(e) => setDesignation(e.target.value)}
                        />
                      </div>
                      <div className="col-lg-6 col-md-6 col-12 mt-md-0 mt-4">
                        <label
                          htmlFor="organization"
                          className="form-label"
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          Organization
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="organization"
                          placeholder="Enter organization"
                          value={organization}
                          onChange={(e) => setOrganization(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="row my-4">
                      <div className="col-lg-6 col-md-6 col-12">
                        <label
                          htmlFor="addressLine1"
                          className="form-label"
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          Address Line 1
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="addressLine1"
                          placeholder="Enter address line 1"
                          value={addressLine1}
                          onChange={(e) => setAddressLine1(e.target.value)}
                        />
                      </div>
                      <div className="col-lg-6 col-md-6 col-12 mt-md-0 mt-4">
                        <label
                          htmlFor="addressLine2"
                          className="form-label"
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          Address Line 2
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="addressLine2"
                          placeholder="Enter address line 2"
                          value={addressLine2}
                          onChange={(e) => setAddressLine2(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="row my-4">
                      <div className="col-lg-6 col-md-6 col-12">
                        <label
                          htmlFor="country"
                          className="form-label"
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          Country
                        </label>
                        <Select
                          options={countryOptions}
                          value={country}
                          onChange={setCountry}
                          placeholder="Select Country"
                          isClearable
                        />
                      </div>
                    </div>
                    <div className="row my-4">
                      <div className="col-lg-6 col-md-6 col-12">
                        <label
                          htmlFor="preferredPaymentTerm"
                          className="form-label"
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          Preferred Payment Term
                        </label>
                        <select
                          className="form-control"
                          id="preferredPaymentTerm"
                          value={preferredPaymentTerm}
                          onChange={(e) =>
                            setPreferredPaymentTerm(e.target.value)
                          }
                        >
                          <option value="Advance">Advance</option>
                          <option value="NET 7">Net 7</option>
                          <option value="NET 15">Net 15</option>
                          <option value="NET 30">Net 30</option>
                        </select>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12 mt-md-0 mt-4">
                        <label
                          htmlFor="preferredPaymentMethod"
                          className="form-label"
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          Preferred Payment Method
                        </label>
                        <select
                          className="form-control"
                          id="preferredPaymentMethod"
                          value={preferredPaymentMethod}
                          onChange={(e) =>
                            setPreferredPaymentMethod(e.target.value)
                          }
                        >
                          <option value="Cash">Cash</option>
                          <option value="Card">Card</option>
                          <option value="Bank Transfer">Bank Transfer</option>
                        </select>
                      </div>
                    </div>

                    <div className="row my-4">
                      <div className="col-lg-6 col-md-6 col-12 mt-md-0 mt-4">
                        <label
                          htmlFor="profileType"
                          className="form-label"
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          Profile Type
                        </label>
                        <select
                          className="form-control"
                          id="profileType"
                          value={profileType}
                          onChange={(e) =>
                            setProfileType(e.target.value)
                          }
                        >
                          <option value="User">User</option>
                          <option value="Reseller">Reseller</option>
                        </select>
                      </div>
                    </div>
                    
                    <div className='d-flex flex-column flex-sm-row gap-2 mb-3'>
                      <Button className="btn admin-btn" type="submit">
                        Add New User Profile
                      </Button>
                       <Button style={{ backgroundColor: '#5f75a5ff', color: '#d8d6d6ff', border: 'none'}} onClick={()=>{navigate(-1)}} variant="danger">Back</Button>
                    </div>
                  </form>
                </Card.Body>
              </Card>
            </Container>
          </div>
        </div>
      </div>
      {/* UserProfiles Creation Confirmation Modal */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>User Profiles Created Successfully</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>The User Profiles has been successfully created.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
